import React from 'react'

type LanguageContextType = [string, (newLanguage: string) => void]

export const LanguageContext = React.createContext<LanguageContextType>([
  '',
  () => null,
])
